import React from 'react';
import Lottie from 'lottie-react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Container, DayText, Square, SquareSeparator} from './styles';
import AnimatedSquareBorder from './AnimatedSquareBorder';
import {addDays, format} from 'date-fns';
import {View} from 'react-native';
import {Baratinhaz} from '../../../Interface/Baratinhaz';

type CheckinSquaresProps = {
  streak: number;
  data_checkin: string;
};

const CheckinSquares: React.FC<CheckinSquaresProps> = ({
  streak,
  data_checkin,
}) => {
  const days = Array.from({length: 7}, (_, index) => index + 1);

  const renderCoin = (autoPlay: boolean, loop: boolean, progress?: number) => (
    <View
      style={{
        height: RFValue(32),

      }}>

      <Baratinhaz />
    </View>
  );

  return (
    <Container>
      {days.map((day, i) => {
        const baseDate = new Date();
        const today = format(baseDate, 'dd/MM/yyyy');
        const checkinDate = data_checkin
          ? format(new Date(data_checkin), 'dd/MM/yyyy')
          : '';
        const checkinIsToday = today === checkinDate;

        let currentDay;
        if (streak === 0) {
          currentDay = 0;
        } else if (streak % 7 === 0) {
          // Se for múltiplo de 7, marca todos como checked somente se o check-in foi feito hoje
          currentDay = checkinIsToday ? 7 : 0;
        } else {
          currentDay = streak % 7;
        }

        const checked = day <= currentDay;

        const currentDate = format(addDays(baseDate, i), 'dd/MM/yyyy');
        const isLatest = currentDate === today && !checked;

        const squareContent = (
          <>
            {checked ? renderCoin(true, true) : renderCoin(true, true, 0.6)}
            <DayText checked={checked}>Dia {i + 1}</DayText>
          </>
        );

        return (
          <React.Fragment key={day}>
            <AnimatedSquareBorder show={isLatest}>
              <Square checked={checked} isLatest={isLatest}>
                {squareContent}
              </Square>
            </AnimatedSquareBorder>
            {i < days.length - 1 && <SquareSeparator checked={checked} />}
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default CheckinSquares;
